import Event, { IEvent } from '@/models/Event'
import ModelBase, { IModelBase } from '@/models/ModelBase'
import User, { IUser } from '@/models/User'
import { KeyPair } from '@/types/KeyPair'

export interface IEventUser extends IModelBase {
  event?: IEvent
  user?: IUser
  active: boolean
  user_event_id?: string
}

export default class EventUser extends ModelBase {
  event?: Event
  user?: User
  active: boolean
  user_event_id?: string

  constructor(defaults?: IEventUser) {
    super(defaults)
    if (defaults) {
      this.event = defaults.event ? new Event(defaults.event) : undefined
      this.user = defaults.user ? new User(defaults.user) : undefined
      this.active = defaults.active
      this.user_event_id = defaults.user_event_id
    }
  }

  toParams(): KeyPair {
    return {}
  }
}
